const CryptoButtonTypeEnum = {
  PRIMARY: 'primary',
  SECONDARY: 'secondary'
};

export default CryptoButtonTypeEnum;
